import * as React from "react";
import { Path, UseFormRegisterReturn } from "react-hook-form";
import { FormTypes } from "src/components/shared/FormTypes";
import InputWrapper from "../InputWrapper/InputWrapper";
import { StyledTextarea } from "./TextareaInput.components";

interface Props extends React.ComponentPropsWithoutRef<"textarea"> {
  errorMessage?: string;
  label: Path<FormTypes>;
  register?: UseFormRegisterReturn;
}

const TextareaInput: React.FunctionComponent<Props> = ({
  label,
  name,
  value,
  errorMessage,
  onChange,
  placeholder,
  register,
  ...rest
}) => (
  <InputWrapper
    withPlaceholder={!!placeholder}
    label={label}
    name={name}
    errorMessage={errorMessage}>
    <StyledTextarea
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      name={name}
      id={name}
      autoComplete="off"
      {...(register && register)}
      {...rest}
    />
  </InputWrapper>
);

export default TextareaInput;
